import React from 'react'
import { useNewTranslation } from 'hooks/index'
import RoundTag from 'particles/Tag'

const ResubmittedIndicator: React.FC = () => {
    const [t] = useNewTranslation()

    return <RoundTag contentType="warning" label={t('submission.table.submissionTypeLabel.resubmittedSubmission')} />
}

export default ResubmittedIndicator
